
export class Module {
  id: number;
  title: string;
  active: number;
  description: string;
}
